import React, { useState } from 'react';
import useDoubleClick from 'utils/customHooks/useDoubleClick';
import ThreeDotMenu from './ThreeDotMenu';

const MessageBox = ({ showDots = true, text, children }) => {
    const [isLiked, setIsLiked] = useState(false);

    const likeMessage = () => {
        setIsLiked(true);
        // TODO here we should have a message object value of "isLiked: 1 : 0" - DEA
        console.log('message is liked: ', elem, refCallback);
    }


    const handleDelete = (item) => {
        console.log('handle message delete', item);
    }

    const handleReport = (item) => {
        console.log('handle message report', item);
    }

    const handleCopy = (item) => {
        console.log('handle message copy', item);
    }

    const handleUnlike = (item) => {
        console.log('handle message unlike', item);
    }

    const [refCallback, elem] = useDoubleClick(likeMessage);

    return (
        <div ref={refCallback}
            className={'d-flex flex-column py-2 message-box-container'}
            style={{
                boxSizing: 'border-box',
            }}>

            <div className={'message-wrapper d-flex'}>
                <div className={'message-content-container border-radius-modal px-3 py-2'}>
                    {
                        text ?
                            <div className={'font-size-12 text-light'}>{text}</div> :
                            null
                    }
                    {children}
                </div>

                {
                    showDots ?
                        <ThreeDotMenu
                            customClass={'px-1'}
                            handleDelete={handleDelete}
                            handleReport={handleReport}
                            handleCopy={handleCopy}
                            handleUnlike={handleUnlike} /> :
                        null
                }
            </div>
            {
                isLiked ?
                    'liked' :
                    null
                // TODO here we should check doubleTap and if so (doubleTapped), then show heart icon filled - liked icon
            }
        </div>
    )
}

export default MessageBox;